<ul class="navbar-nav main-navigation main-navigation-list">
  <ish-lazy-content-include includeId="include.icsa.header.navigation.pagelet2-Include" />
  <!-- <custom-dot-cms-uve-header></custom-dot-cms-uve-header> -->
  <ng-container *ishFeature="'dotCmsUve'">
    <!-- <custom-dot-cms-uve-header /> -->
    <ng-container *ngComponentOutlet="lazyComponent$ | async" />
    <!-- <custom-lazy-dot-cms-uve-header /> -->
  </ng-container>
</ul>
